import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 58 — GoHighLevel specialist-role cluster service links.
 *
 * Every Batch 58 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch58Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH58_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-certification-worth-it": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /certified user who has never shipped a snapshot is a certified user who cannot architect the system/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-conversation-ai-setup-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /chatbot that ships without the fallback is a chatbot that loses the lead/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-email-deliverability-a2p-specialist": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /campaign that ships without the 10DLC registration is a campaign the carrier blocks/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-sub-account-operations-manager": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /client base that scales without the SOPs is a client base that breaks on the first update/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
